export function trimReturnKey(text: string): string {
	let s = text.trim().replace(/\r?\n/g, '');
	return s;
}
